const getPropsTagChipStatus = (status) => {
  let label = '';
  let kind = '';

  switch (status) {
    case 'active':
      label = 'Ativo';
      kind = 'success';
      break;
    case 'future':
      label = 'Agendado';
      kind = 'scheduled';
      break;
    case 'canceled':
      label = 'Cancelado';
      kind = 'warning';
      break;
    case 'expired':
      label = 'Expirado';
      kind = 'attention';
      break;
    default:
      label = 'Ativo';
      kind = 'success';
  }

  return { label, kind };
};

export default getPropsTagChipStatus;
